import type { QueueItem } from "@/types/ticket";

/** Sidebar ticket queues — labels only; counts load from API when available. */
export const queues: QueueItem[] = [
  { id: "all", label: "All Tickets", icon: "inbox", count: 0 },
  { id: "unassigned", label: "Unassigned", icon: "user-x", count: 0 },
  { id: "my-tickets", label: "My Tickets", icon: "user", count: 0 },
  { id: "vip", label: "VIP Requests", icon: "star", count: 0 },
  { id: "kanban", label: "Kanban Board", icon: "kanban", count: 0 },
];

export const assetQueues: QueueItem[] = [
  { id: "all", label: "All Assets", icon: "inbox", count: 0 },
  { id: "active", label: "Active", icon: "check-circle", count: 0 },
  { id: "inactive", label: "Inactive", icon: "user-x", count: 0 },
  { id: "maintenance", label: "Maintenance", icon: "alert-circle", count: 0 },
  { id: "unassigned", label: "Unassigned", icon: "user-x", count: 0 },
  { id: "my-assets", label: "My Assets", icon: "user", count: 0 },
  { id: "expiring", label: "Expiring Soon", icon: "clock", count: 0 },
  { id: "retired", label: "Retired", icon: "archive", count: 0 },
];
